module.exports = __webpack_public_path__ + "img/0Q3A7250_FoamcoreMatted.0ddb403d.jpg";